import React from 'react';
import styled from 'styled-components';

import { IconNames } from 'components/Icons/IconList';
import Icon from 'components/Icons/Icon';

const ItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 3.75rem;
`;

const SvgContainer = styled.div`
  ${({ theme }) => theme.gfx.mixins.mb(1)}
`;

const Name = styled.p`
  color: ${({ theme }) => theme.themeColorOpacities.fg70};
  white-space: pre-line;
  text-align: center;
  line-height: 1.25rem;
`;

interface ITechItem {
  name: string;
}

const TechItem: React.FC<ITechItem> = ({ name }: ITechItem) => {
  const determineSvgName = (name: string): IconNames | null => {
    switch (name) {
      case 'D3':
        return 'DTHREE';
      case 'Ruby on Rails':
        return 'RubyOnRails';
      case 'React Native':
        return 'ReactNative';
      case 'Google Optimize':
        return 'GoogleOptimize';
      case 'Google Analytics':
        return 'GoogleAnalytics';
      case 'Three.js':
        return 'Threejs';
      case 'Next.js':
        return 'Nextjs';
      default:
        return name as IconNames;
    }
  };

  return (
    <ItemContainer>
      <SvgContainer>
        <Icon name={determineSvgName(name) as IconNames} />
      </SvgContainer>
      <Name>{name}</Name>
    </ItemContainer>
  );
};

export default TechItem;
